module.exports = __webpack_public_path__ + "img/3.acb9e504.png";